// src/utils/themeUtils.js
import { CustomTheme1 } from "../css/CustomTheme1.css";
import { CustomTheme2 } from "../css/CustomTheme2.css";
import { CustomTheme3 } from "../css/CustomTheme3.css";
import { CustomTheme4 } from "../css/CustomTheme4.css";
import { CustomTheme5 } from "../css/CustomTheme5.css";

export const getThemeStyles = (themeName) => {
    switch (themeName) {
        case "theme1":
            return CustomTheme1();
        case "theme2":
            return CustomTheme2();
        case "theme3":
            return CustomTheme3();
        case "theme4":
            return CustomTheme4();
        case "theme5":
            return CustomTheme5();
        default:
            return CustomTheme1();
    }
};
